import React, { useState, useEffect } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './Testimonials.css';

const VISIBLE = 3;
const GAP = 24;
const MOBILE_BREAKPOINT = 860;
const AUTOPLAY_INTERVAL = 3500;

const reviews = [
  {
    name: 'Floyd Miles',
    role: 'Project Manager',
    quote:
      'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry standard dummy text.',
  },
  {
    name: 'Jane Cooper',
    role: 'Marketing Lead',
    quote:
      'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry standard dummy text.',
  },
  {
    name: 'Floyd Miles',
    role: 'Project Manager',
    quote:
      'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry standard dummy text.',
  },
  {
    name: 'Jane Cooper',
    role: 'Marketing Lead',
    quote:
      'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry standard dummy text.',
  },
  {
    name: 'Floyd Miles',
    role: 'Project Manager',
    quote:
      'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry standard dummy text.',
  },
  {
    name: 'Jane Cooper',
    role: 'Marketing Lead',
    quote:
      'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry standard dummy text.',
  },
  {
    name: 'Floyd Miles',
    role: 'Project Manager',
    quote:
      'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry standard dummy text.',
  },
  {
    name: 'Jane Cooper',
    role: 'Marketing Lead',
    quote:
      'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry standard dummy text.',
  },
];

function Testimonials() {
  useStyles(s);

  const [index, setIndex] = useState(0);
  const [perView, setPerView] = useState(VISIBLE);

  useEffect(() => {
    const update = () =>
      setPerView(window.innerWidth <= MOBILE_BREAKPOINT ? 1 : VISIBLE);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  const maxIndex = Math.max(0, reviews.length - perView);
  const activeIndex = Math.min(index, maxIndex);

  // Wrap around so the carousel loops infinitely: past the last slide jumps
  // back to the first, and before the first jumps to the last.
  const prev = () => setIndex(i => (i <= 0 ? maxIndex : i - 1));
  const next = () => setIndex(i => (i >= maxIndex ? 0 : i + 1));

  // Auto-play: advance one slide every few seconds, pausing while hovered.
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused || maxIndex === 0) return undefined;
    const id = setInterval(() => {
      setIndex(i => (i >= maxIndex ? 0 : i + 1));
    }, AUTOPLAY_INTERVAL);
    return () => clearInterval(id);
  }, [paused, maxIndex]);

  // Card width and slide distance share the same expression so the track stays
  // aligned regardless of how many cards are visible per view.
  const basis = `(100% - ${(perView - 1) * GAP}px) / ${perView}`;

  return (
    <section className={s.testimonials}>
      <div className={s.inner}>
        <div className={s.header}>
          <p className={s.eyebrow}>Testimonials</p>
          <h2 className={s.title}>Our Happy Customers</h2>
          <p className={s.text}>
            Retail food delivery is a courier service in which a restaurant,
            store, or independent food delivery company delivers food to a
            customer. An order is typically made.
          </p>
        </div>

        <div
          className={s.viewport}
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          <div
            className={s.track}
            style={{
              transform: `translateX(calc(-1 * ${activeIndex} * (${basis} + ${GAP}px)))`,
            }}
          >
            {reviews.map((r, i) => (
              <div
                key={i}
                className={s.card}
                style={{ flex: `0 0 calc(${basis})` }}
              >
                <div className={s.cardHead}>
                  <p className={s.name}>{r.name}</p>
                  <p className={s.role}>{r.role}</p>
                </div>
                <p className={s.quote}>{r.quote}</p>
                <p className={s.stars}>★★★★★</p>
              </div>
            ))}
          </div>
        </div>

        <div className={s.nav}>
          <button
            type="button"
            className={`${s.navBtn} ${s.navBtnPrev}`}
            onClick={prev}
            aria-label="Previous testimonials"
          >
            ←
          </button>
          <button
            type="button"
            className={`${s.navBtn} ${s.navBtnNext}`}
            onClick={next}
            aria-label="Next testimonials"
          >
            →
          </button>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
